export const AnnouncementBar = () => (
  <div data-testid="promo-banner"
    className="fixed top-0 left-0 right-0 z-[60] h-9 bg-ink text-[#F2D486] border-b border-line-dark flex items-center">
    <div className="w-full text-center label flex items-center justify-center gap-3 px-4">
      <span className="hidden sm:inline">Buy 2 prints, save 15%</span>
      <span className="hidden sm:inline text-wheat" aria-hidden>✳</span>
      <span>Buy 3 or more, save 25%</span>
      <span className="text-wheat" aria-hidden>✳</span>
      <span className="hidden md:inline">Always fast, free shipping</span>
    </div>
  </div>
);
